import { FoodsToggleButton, FoodsToggleButtonType } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { ActionPlanPlanningTabs, OneInLocalStorage } from "src/services/OneFromLocalStorage";
import { TabHeader } from "../TabHeader";

type PlanningListHeaderProps = {
    selectedButton: ActionPlanPlanningTabs;
};
export const ActionPlanLayout = (props: PlanningListHeaderProps) => {
    const theme = useTheme();
    const { actionId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { urls } = useActionsContext();

    const buttons: FoodsToggleButtonType[] = [
        {
            id: 1,
            label: "Liste des actions",
            startIcon: "actionPlan",
            onClick: () => {
                OneInLocalStorage.setItem("actionPlan-planning-tabs", "list");
                navigate(urls.planning());
            },
        },
        {
            id: 2,
            label: "Aperçu",
            startIcon: "waterfall",
            onClick: () => {
                OneInLocalStorage.setItem("actionPlan-planning-tabs", "preview");
                navigate(urls.planningPreview());
            },
        },
    ];
    const initialButton = props.selectedButton === "list" ? buttons[0] : buttons[1];

    const shouldShowTabs = props.selectedButton !== "list" ? true : actionId === undefined;
    return (
        <Stack gap={theme.spacing(4)} width={"100%"}>
            <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <TabHeader title={t("actions.planning.title")} />
                <Stack>
                    {buttons.length > 0 && shouldShowTabs && (
                        <FoodsToggleButton
                            buttons={buttons}
                            initialSelected={initialButton ?? buttons[0]}
                            buttonGroup
                        />
                    )}
                </Stack>
            </Stack>
            <Stack>
                <Outlet />
            </Stack>
        </Stack>
    );
};
